import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ServerRootService } from "../utils/routing/serverroot.service";
import { Observable } from "rxjs";
import { RemoteConsultationParams } from "../models";

@Injectable({
    providedIn: 'root',
})
export class RemoteTeleconsultationService {

    constructor(
        private http: HttpClient,
        private serverRoot: ServerRootService
    ) { }

    getRemoteConsultationWorklistUrl(): Observable<string> {
        return this.http.post<string>(
            this.serverRoot.getServerRoot() + '/RemoteConsultation/GetRemoteConsultationWorklistUrl',
            this.serverRoot.buildOptions()
        )
    }

    createRemoteConsultationUrl(params: RemoteConsultationParams): Observable<string> {
        return this.http.post<string>(
            this.serverRoot.getServerRoot() + '/RemoteConsultation/CreateRemoteConsultationUrl',
            params,
            this.serverRoot.buildOptions()
        )
    }

    goToTeleconsultation(url: string) {
        window.open(url);
    }
}
